const toJson = (item) => {
    return {
        id: item.id,
        appleID: item.appleID,
        fullName: item.fullName,
        donVi: item.donVi,
        ghiChu: item.ghiChu,
        daGiaiQuyet: item.daGiaiQuyet
    }
}
const fromJson = (item) => {
    return {
        id: item.id,
        appleID: item.appleID,
        fullName: item.fullName,
        donVi: item.donVi,
        ghiChu: item.ghiChu,
        daGiaiQuyet: item.daGiaiQuyet,
        createAt:item.createAt,
        modifiedAt: item.modifiedAt,
        createdBy: item.createdBy,
        modifiedBy: item.modifiedBy,
        lastModifiedShow: item.lastModifiedShow,
        createdAtShow : item.createdAtShow
    }
}

const baseJson = () => {
    return {
        id: null,
        appleID: null,
        fullName: null,
        donVi: null,
        ghiChu: null,
        daGiaiQuyet: false,
        createdAt: null,
        modifiedAt: null,
        createdBy: null,
        modifiedBy: null,
    }
}

const toListModel = (items) =>{
    if(items.length > 0){
        let data = [];
        items.map((value, index) =>{
            data.push(fromJson(value));
        })
        return data??[];
    }
    return [];
}

export const appleConnectorModel = {
    toJson, fromJson, baseJson, toListModel
}
